<template>
  <div class="menu_circle"
  :class="{'btn_topbar_active': topBarConfig.user.ucode}">
    <label for="klickbox-step-add-buttons-container">
      <input type="checkbox" id="klickbox-step-add-buttons-container">
      <span class="btn_circle btn_circle__big">
        <i class="kp-panel-plus"></i>
      </span>
      <div class="btn_circle-tooltip" v-show="stepHasOnlyThanks">{{ $t('edit.sidebar.add_one_question') }}</div>
      <div class="menu_circle-list">
        <span class="btn_circle btn_circle__red" title="múltipla escolha" @click="stepAdd('multiple-choice')">
          <i class="kp-panel-alternative"></i>
          <span class="btn_circle-subtitle">{{ $t('edit.sidebar.question') }}</span>
        </span>
        <span class="btn_circle btn_circle__pink" title="sim/não" @click="stepAdd('yes-no')">
          <i class="kp-panel-yes-no"></i>
          <span class="btn_circle-subtitle">{{ $t('edit.sidebar.yes_no') }}</span>
        </span>
        <span class="btn_circle btn_circle__purple" title="texto" @click="stepAdd('text')">
          <i class="kp-panel-text"></i>
          <span class="btn_circle-subtitle">{{ $t('edit.sidebar.text') }}</span>
        </span>
        <span class="btn_circle btn_circle__blue" title="e-mail" @click="stepAdd('email')">
          <i class="kp-panel-register"></i>
          <span class="btn_circle-subtitle">{{ $t('edit.sidebar.capture') }}<br>{{ $t('edit.sidebar.of_email') }}</span>
        </span>
        <span class="btn_circle btn_circle__green" title="link" @click="stepAdd('redirect')">
          <i class="icon-kp-link"></i>
          <span class="btn_circle-subtitle">{{ $t('edit.sidebar.redirec') }}-<br>{{ $t('edit.sidebar.tion') }}</span>
        </span>
      </div>
    </label>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: mapActions([
    'stepAdd',
  ]),
  computed: mapGetters({
    stepHasOnlyThanks: 'stepHasOnlyThanks',
    topBarConfig: 'topBar/config',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** ButtonAdd.vue?56ad3b3f
 **/